export default __webpack_public_path__ + "static/media/virat_kohli.6e33341e.png";